import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import i18n from './../i18n';
import queryString from 'query-string';
import logo from './images/logo.svg';
import bgbottom from './images/bgbottom.svg';
import iconsonny from './images/Icon-Sonny.svg';



class LanguageSelectorClass extends Component {
    userData1;

    constructor(props) {
        super(props);


        this.state = {
            lang: 'en'

        }



    }


    changeLanguage = (event) => {
      
        event.preventDefault()
        i18n.changeLanguage(event.target.getAttribute('data-value'));
        this.setState({
            lang: event.target.getAttribute('data-value')

        });
        
        this.props.sethide('hide');
      // window.location.reload(false);
       window.location = window.location.pathname + '?language=' + event.target.getAttribute('data-value');
        
 return false
    }



    componentDidMount() {
        this.userData1 = JSON.parse(localStorage.getItem('user1'));

        const querystring = queryString.parse(window.location.search);


        if (localStorage.getItem('user1')) {
            this.setState({
                lang: this.userData1.lang

            })

            i18n.changeLanguage(this.userData1.lang);
        } else {

            this.setState({
                lang: 'en'

            })

        }


        if (querystring.language === 'en') {

            this.setState({
                lang: 'en'

            });
            i18n.changeLanguage('en');
        }

        if (querystring.language === 'es') {

            this.setState({
                lang: 'es'

            });
            i18n.changeLanguage('es');
        }

        if (querystring.language === 'fr') {

            this.setState({
                lang: 'fr'

            });
            i18n.changeLanguage('fr');
        }

        if (querystring.language === 'pt') {

            this.setState({
                lang: 'pt'

            });
            i18n.changeLanguage('pt');
        }


        //i18n.changeLanguage(init_lang); 

        ////

        // console.log(this.state.lang)


    }

    componentWillUpdate(nextProps, nextState) {
        localStorage.setItem('user1', JSON.stringify(nextState));

    }



    render() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className="sticky-top">
                   
                    <div className="topbar text-right">
                       
                    <div className="dropdown">
                            <button type="button" className="btn dropdown-toggle mr-1 top_btn" data-toggle="dropdown">
                                {t('lang.country')}
			            </button>
                        <button type="button" className="btn top_btn">
                                {i18n.language === '' ? 'en' : i18n.language}
                        </button>
                   
                    <div className="dropdown-menu dropdown-menu-right">
                                <button className="dropdown-item" data-value="en"  onClick={this.changeLanguage} >{t('lang.en')}</button>
                                <button className="dropdown-item" data-value="es"  onClick={this.changeLanguage}>{t('lang.es')}</button>
                                <button className="dropdown-item" data-value="fr" onClick={this.changeLanguage}>{t('lang.fr')}</button>
                                <button className="dropdown-item" data-value="pt" onClick={this.changeLanguage}>{t('lang.pt')}</button>
                    </div>
                </div>

            </div>

            <header>
                <img src={bgbottom} alt="WellAway" />
                <div className="head ">
                    <div className="logo-img">
                                <a href={'https://www.wellaway.com/'+i18n.language+'/'}> <img src={logo} alt="WellAway Logo" /></a>
                    </div>
                    <p className="p18 d-md-block d-none">{t('logo.title')}</p>
                </div>
            </header>
                </div>

                <div className="sonny text-center d-md-block ">
                    <img src={iconsonny} alt="Icon Sonny" />
                </div>

 

            </React.Fragment> 
        )
    }
}

export default withTranslation()(LanguageSelectorClass);